import { WallButton } from "@package/ui-components";
import { EventPayloadType } from "@package/ui-gql/index-analytics";
import { type SliceWallScreenState } from "@package/ui-wall-engine";
import { useWallAnalytics } from "../../context/context-analytics/context-analytics";
import { useWallProvider } from "../../context/context-wall/context-wall";

type FlyoutCloseButtonProps = {
  screen: SliceWallScreenState;
};

export function FlyoutCloseButton({ screen }: FlyoutCloseButtonProps) {
  const provider = useWallProvider();
  const { trigger } = useWallAnalytics();

  if (screen.flyout?.post?.flyoutShowCloseButton) {
    return (
      <div className="absolute bottom-4 right-0">
        <WallButton
          align="right"
          icon="cross"
          intent="danger"
          onHandleMouse={(x, y) => {
            provider?.onFlyoutClosed(screen.id);
            trigger(
              EventPayloadType.PostClosed,
              {
                position: {
                  x,
                  y,
                },
                screen: screen.index,
              },
              screen.flyout?.post?.id ?? undefined,
              screen.layout?.id ?? undefined,
            );
          }}
        />
      </div>
    );
  }

  return null;
}
